const baseUrl = process.env.REACT_APP_BASE_URL + 'Analytics';

const AnalyticsApiService = {
  // Fetch all analytics records
  getAll: async () => {
    try {
      const response = await fetch(`${baseUrl}`, {
        method: 'GET',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  GetAnalyticsForGraph: async (userId, graphType) => {
    try {
      const response = await fetch(`${baseUrl}/GetAnalyticsForGraph`, {
        method: 'POST', // Changed to POST assuming request needs a body
        credentials: "include",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: userId,
          GraphType: graphType,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  // Add a new analytics record
  addAnalytics: async (analyticsData) => {
    try {
      const response = await fetch(`${baseUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(analyticsData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error adding analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Fetch a single analytics record by ID
  getById: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Analytics record not found');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  GetUserAnalytics: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/GetUserAnalytics/${id}`, {
        method: 'GET',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Analytics record not found');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },




  // Update an existing analytics record by ID
  updateAnalytics: async (id, analyticsData) => {
    try {
      const response = await fetch(`${baseUrl}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(analyticsData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error updating analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Delete an analytics record by ID
  deleteAnalytics: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error deleting analytics data');
      }

      return true; // Return true on successful deletion
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
};

export default AnalyticsApiService;
